import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./SwalService.scss";

// import { AppIcons } from "../../data/appIcons";

export const SwalServices = withReactContent(Swal);

const customClass = {
  container: "",
  popup: "",
  header: "",
  title: "",
  closeButton: "",
  icon: "",
  image: "",
  htmlContainer: "",
  input: "",
  inputLabel: "",
  validationMessage: "",
  actions: "",
  confirmButton: "btn theme-button",
  denyButton: "btn theme-button",
  cancelButton: "btn dark-btn",
  loader: "",
  footer: "",
  timerProgressBar: "",
};

export function SwalAlert(t) {
  const safeT = typeof t === "function" ? t : (key) => key;

  const success = (text, title, showConfirmButton = false, confirmButtonText, customClass = "swal-fire") => {
    return SwalServices.fire({
      title: title,
      text: text,
      icon: "success",
      showConfirmButton: showConfirmButton,
      confirmButtonText: confirmButtonText || safeT('common.ok'),
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: customClass,
    });
  };

  const error = (text, title, customClass = "swal-fire") => {
    return SwalServices.fire({
      title: title,
      text: text,
      icon: "error",
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: customClass,
    });
  };

  const rejection = (title, reason, textBelow, confirmButtonText, customClass = "swal-fire swal-rejection-modal") => {
    return SwalServices.fire({
      title: title,
      html: `
        <div class="swal-rejection-container">
          <div class="swal-rejection-reason-box">
            <span class="swal-rejection-reason-label">${safeT("validation.rejection_reason_label") || "Reason for Rejection"}:</span>
            <p class="swal-rejection-reason-text">${reason}</p>
          </div>
          <p class="swal-rejection-footer">${textBelow}</p>
        </div>
      `,
      icon: "error",
      showConfirmButton: true,
      confirmButtonText: confirmButtonText || safeT('common.ok'),
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: customClass,
    });
  };

  const warning = (title, text, showConfirmButton = false, confirmButtonText,
    showCancelButton = false, cancelButtonText, customClass = "swal-fire") => {
    return SwalServices.fire({
      position: "center",
      title: title,
      text: text,
      showConfirmButton: showConfirmButton,
      confirmButtonText: confirmButtonText || safeT('common.ok'),
      showCancelButton: showCancelButton,
      cancelButtonText: cancelButtonText || safeT('common.cancel'),
      icon: "warning",
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: customClass,
    }).then((result) => result.isConfirmed);
  };

  const info = (title, text, showConfirmButton = false, confirmButtonText,
    showCancelButton = false, customClass = "swal-fire") => {
    return SwalServices.fire({
      title: title,
      text: text,
      showConfirmButton: showConfirmButton,
      confirmButtonText: confirmButtonText || safeT('common.ok'),
      showCancelButton: showCancelButton,
      cancelButtonText: safeT('common.cancel'),
      icon: "info",
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: customClass,
    }).then((result) => result.isConfirmed);
  };

  const confirm = (
    title,
    text,
    saveBtnText,
    cancelBtnText,
    isCancelButton,
    thirdBtnText,
    validationMessage,
    validateCallback,
    placeholderText,
    includeTextarea = false,
  ) => {
    const textareaHtml = includeTextarea ? `
      <textarea id="swal-textarea" class="swal-textarea" placeholder="${placeholderText}" style="width:100%; height:100px; margin-top:10px;"></textarea>
      <div id="validation-message" class="swal-validation-error" style="display: none;">${validationMessage}</div>
    ` : '';

    return SwalServices.fire({
      title: title,
      html: `
        <p>${text}</p>
        ${textareaHtml}
      `,
      icon: "question",
      showCancelButton: isCancelButton === false ? isCancelButton : true,
      confirmButtonText: saveBtnText,
      cancelButtonText: cancelBtnText,
      showDenyButton: !!thirdBtnText,
      denyButtonText: thirdBtnText || "",
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: customClass,
      preConfirm: () => {
        if (includeTextarea) {
          const textareaValue = document.getElementById("swal-textarea").value.trim();

          const isValid = validateCallback(textareaValue);
          if (!isValid) {
            document.getElementById("validation-message").style.display = "block";
            return false;
          }
          return textareaValue;
        }
        return true;
      }
    }).then((result) => {
      if (result.dismiss === SwalServices.DismissReason.cancel) {
        return false;
      }

      if (result.isDenied) {
        return "third"; // <-- Return something identifiable for the third button
      }

      if (result.value) {
        return result.value;
      }

      return false;
    });
  };

  const blocked = (title, text, iconUrl, customClass = "swal-fire") => {
    return SwalServices.fire({
      title: title,
      text: text,
      // iconHtml: `<img src="${AppIcons.BlockedIcon}" class="swal-icon"/>`,
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: customClass,
    });
  };


  // Export the SwalService functions
  return { confirm, success, warning, info, error, blocked, rejection };
};

